// this file was prevaled
// This file needs to be a JavaScript file using CommonJS to work with preval
// this file was prevaled
// we're using preval because we import tokens into Fuegokit React as a module
// Cache bust: Jul 19 2023 9:34:35 GMT-0600 (This file is cached by the system's deployment tooling, so you'll need update this timestamp to rebuild this file)
// const {default: styles} = require('../temporary/styles/dist/js')
var themePreval = {
  "theme": {
    "fontStack": {
      "normal": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`",
      "mono": "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace",
      "title": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`",
      "sansSerif": "ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "monospace": "ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
      "body": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif"
    },
    "fontFamily": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace",
      "title": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\""
    },
    "animation": {
      "easeOutCubic": "cubic-bezier(0.33, 1, 0.68, 1)"
    },
    "borderWidths": [0, "1px"],
    "breakpoints": ["350px", "544px", "768px", "1012px", "1280px"],
    "fonts": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace",
      "title": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\""
    },
    "fontSizes": ["10px", "11px", "12px", "14px", "16px", "18px", "20px", "24px", "28px", "29px", "35px", "36px", "47px", "62px"],
    "fontWeights": {
      "light": 300,
      "normal": 400,
      "medium": 500,
      "semibold": 600,
      "bold": 700,
      "extraLight": 200
    },
    "lineHeights": {
      "default": 1.429,
      "condensed": 1.143,
      "condensedUltra": 1,
      "relaxed": 1.714
    },
    "radii": ["0px", "3px", "4px", "6px", "8px", "9999999px"],
    "size": {
      "4": "4px",
      "8": "8px",
      "12": "12px",
      "16": "16px",
      "20": "20px",
      "24": "24px",
      "28": "28px",
      "32": "32px",
      "36": "36px",
      "40": "40px",
      "44": "44px",
      "48": "48px",
      "64": "64px",
      "80": "80px",
      "96": "96px",
      "112": "112px",
      "128": "128px",
      "144": "144px"
    },
    "space": ["0px", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"],
    "colorSchemes": {
      "light": {
        "colors": {
          "text": {
            "default": "#172B4D",
            "subtle": "#44546F",
            "subtlest": "#626F86",
            "disabled": "#8590A2",
            "inverse": "#FFFFFF",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#AE2A19",
            "success": "#216E4E",
            "discovery": "#5E4DB2",
            "information": "#0055CC",
            "accent": {
              "blue": {
                "default": "#0055CC",
                "bolder": "#09326C"
              },
              "red": {
                "default": "#AE2A19",
                "bolder": "#601E16"
              },
              "orange": {
                "default": "#974F0C",
                "bolder": "#5F3811"
              },
              "yellow": {
                "default": "#7F5F01",
                "bolder": "#533F04"
              },
              "green": {
                "default": "#216E4E",
                "bolder": "#164B35"
              },
              "purple": {
                "default": "#5E4DB2",
                "bolder": "#352C63"
              },
              "teal": {
                "default": "#206B74",
                "bolder": "#1D474C"
              },
              "magenta": {
                "default": "#943D73",
                "bolder": "#50253F"
              },
              "gray": {
                "default": "#44546F",
                "bolder": "#091E42"
              },
              "lime": {
                "default": "#4C6B1F",
                "bolder": "#37471F"
              }
            },
            "warning": {
              "default": "#974F0C",
              "inverse": "#172B4D"
            }
          },
          "icon": {
            "default": "#44546F",
            "subtle": "#626F86",
            "inverse": "#FFFFFF",
            "disabled": "#8590A2",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#B38600",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D",
              "gray": "#758195",
              "lime": "#6A9A23"
            },
            "warning": {
              "default": "#D97008",
              "inverse": "#172B4D"
            }
          },
          "border": {
            "default": "#091e4224",
            "inverse": "#FFFFFF",
            "focused": "#388BFF",
            "input": "#091e4224",
            "disabled": "#091e420f",
            "brand": "#0C66E4",
            "selected": "#0C66E4",
            "danger": "#E34935",
            "warning": "#D97008",
            "success": "#22A06B",
            "discovery": "#8270DB",
            "information": "#1D7AFC",
            "subtle": "#091e420f",
            "accent": {
              "blue": "#1D7AFC",
              "red": "#E34935",
              "orange": "#D97008",
              "yellow": "#B38600",
              "green": "#22A06B",
              "purple": "#8270DB",
              "teal": "#1D9AAA",
              "magenta": "#CD519D",
              "gray": "#758195"
            },
            "table": {
              "default": "#091e4224"
            }
          },
          "background": {
            "disabled": "#F1F2F4",
            "accent": {
              "blue": {
                "subtlest": "#E9F2FF",
                "subtler": "#CCE0FF",
                "subtle": "#579DFF",
                "bolder": "#0C66E4"
              },
              "red": {
                "subtlest": "#FFEDEB",
                "subtler": "#FFD2CC",
                "subtle": "#F87462",
                "bolder": "#CA3521"
              },
              "orange": {
                "subtlest": "#FFF4E5",
                "subtler": "#FFE2BD",
                "subtle": "#FAA53D",
                "bolder": "#B65C02"
              },
              "yellow": {
                "subtlest": "#FFF7D6",
                "subtler": "#F8E6A0",
                "subtle": "#E2B203",
                "bolder": "#946F00"
              },
              "green": {
                "subtlest": "#DFFCF0",
                "subtler": "#BAF3DB",
                "subtle": "#4BCE97",
                "bolder": "#1F845A"
              },
              "teal": {
                "subtlest": "#E3FAFC",
                "subtler": "#C1F0F5",
                "subtle": "#60C6D2",
                "bolder": "#1D7F8C"
              },
              "purple": {
                "subtlest": "#F3F0FF",
                "subtler": "#DFD8FD",
                "subtle": "#9F8FEF",
                "bolder": "#6E5DC6"
              },
              "magenta": {
                "subtlest": "#FFECF8",
                "subtler": "#FDD0EC",
                "subtle": "#E774BB",
                "bolder": "#AE4787"
              },
              "gray": {
                "subtlest": "#F1F2F4",
                "subtler": "#DCDFE4",
                "subtle": "#8590A2",
                "bolder": "#626F86"
              },
              "lime": {
                "subtlest": "#EEFBDA",
                "subtler": "#D3F1A7",
                "subtle": "#94C748",
                "bolder": "#5B7F24"
              }
            },
            "inverse": {
              "subtle": {
                "default": "#00000029",
                "hovered": "#0000003d",
                "pressed": "#00000052"
              }
            },
            "input": {
              "default": "#FFFFFF",
              "hovered": "#F7F8F9",
              "pressed": "#FFFFFF"
            },
            "neutral": {
              "default": {
                "[default]": "#091e420f",
                "hovered": "#091e4224",
                "pressed": "#091e4224"
              },
              "subtle": {
                "default": "#00000000",
                "hovered": "#091e420f",
                "pressed": "#091e4224"
              },
              "bold": {
                "default": "#44546F",
                "hovered": "#2C3E5D",
                "pressed": "#172B4D"
              }
            },
            "brand": {
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            },
            "selected": {
              "default": {
                "[default]": "#E9F2FF",
                "hovered": "#CCE0FF",
                "pressed": "#85B8FF"
              },
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            },
            "danger": {
              "default": {
                "[default]": "#FFEDEB",
                "hovered": "#FFD2CC",
                "pressed": "#FF9C8F"
              },
              "bold": {
                "default": "#CA3521",
                "hovered": "#AE2A19",
                "pressed": "#601E16"
              }
            },
            "warning": {
              "default": {
                "[default]": "#FFF7D6",
                "hovered": "#F8E6A0",
                "pressed": "#F8E6A0"
              },
              "bold": {
                "default": "#E2B203",
                "hovered": "#CF9F02",
                "pressed": "#B38600"
              }
            },
            "success": {
              "default": {
                "[default]": "#DFFCF0",
                "hovered": "#BAF3DB",
                "pressed": "#7EE2B8"
              },
              "bold": {
                "default": "#1F845A",
                "hovered": "#216E4E",
                "pressed": "#164B35"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#F3F0FF",
                "hovered": "#DFD8FD",
                "pressed": "#B8ACF6"
              },
              "bold": {
                "default": "#6E5DC6",
                "hovered": "#5E4DB2",
                "pressed": "#352C63"
              }
            },
            "information": {
              "default": {
                "[default]": "#E9F2FF",
                "hovered": "#CCE0FF",
                "pressed": "#85B8FF"
              },
              "bold": {
                "default": "#0C66E4",
                "hovered": "#0055CC",
                "pressed": "#09326C"
              }
            }
          },
          "blanket": {
            "default": "#091e427d",
            "selected": "#388bff14",
            "danger": "#ef5c4814"
          },
          "interaction": {
            "hovered": "#00000029",
            "pressed": "#00000052"
          },
          "skeleton": {
            "default": "#091e420f",
            "subtle": "#091e4208"
          },
          "link": {
            "default": "#0C66E4",
            "pressed": "#0055CC",
            "visited": "#5E4DB2"
          },
          "chart": {
            "brand": {
              "default": "#1D7AFC",
              "hovered": "#0C66E4"
            },
            "neutral": {
              "default": "#8590A2",
              "hovered": "#758195"
            },
            "success": {
              "default": {
                "[default]": "#22A06B",
                "hovered": "#1F845A"
              },
              "bold": {
                "default": "#216E4E",
                "hovered": "#164B35"
              }
            },
            "danger": {
              "default": {
                "[default]": "#EF5C48",
                "hovered": "#E34935"
              },
              "bold": {
                "default": "#AE2A19",
                "hovered": "#601E16"
              }
            },
            "warning": {
              "default": {
                "[default]": "#B38600",
                "hovered": "#946F00"
              },
              "bold": {
                "default": "#7F5F01",
                "hovered": "#533F04"
              }
            },
            "information": {
              "default": {
                "[default]": "#388BFF",
                "hovered": "#1D7AFC"
              },
              "bold": {
                "default": "#0055CC",
                "hovered": "#09326C"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#8F7EE7",
                "hovered": "#8270DB"
              },
              "bold": {
                "default": "#5E4DB2",
                "hovered": "#352C63"
              }
            },
            "categorical": {
              "1": {
                "default": "#1D9AAA",
                "hovered": "#1D7F8C"
              },
              "2": {
                "default": "#5E4DB2",
                "hovered": "#352C63"
              },
              "3": {
                "default": "#D97008",
                "hovered": "#B65C02"
              },
              "4": {
                "default": "#943D73",
                "hovered": "#50253F"
              },
              "5": {
                "default": "#09326C",
                "hovered": "#082145"
              },
              "6": {
                "default": "#8F7EE7",
                "hovered": "#8270DB"
              },
              "7": {
                "default": "#50253F",
                "hovered": "#341829"
              },
              "8": {
                "default": "#974F0C",
                "hovered": "#5F3811"
              }
            },
            "blue": {
              "bold": {
                "default": "#388BFF",
                "hovered": "#1D7AFC"
              },
              "bolder": {
                "default": "#1D7AFC",
                "hovered": "#0C66E4"
              },
              "boldest": {
                "default": "#0055CC",
                "hovered": "#09326C"
              }
            },
            "red": {
              "bold": {
                "default": "#EF5C48",
                "hovered": "#E34935"
              },
              "bolder": {
                "default": "#E34935",
                "hovered": "#CA3521"
              },
              "boldest": {
                "default": "#AE2A19",
                "hovered": "#601E16"
              }
            },
            "orange": {
              "bold": {
                "default": "#D97008",
                "hovered": "#B65C02"
              },
              "bolder": {
                "default": "#B65C02",
                "hovered": "#974F0C"
              },
              "boldest": {
                "default": "#974F0C",
                "hovered": "#5F3811"
              }
            },
            "yellow": {
              "bold": {
                "default": "#B38600",
                "hovered": "#946F00"
              },
              "bolder": {
                "default": "#946F00",
                "hovered": "#7F5F01"
              },
              "boldest": {
                "default": "#7F5F01",
                "hovered": "#533F04"
              }
            },
            "green": {
              "bold": {
                "default": "#22A06B",
                "hovered": "#1F845A"
              },
              "bolder": {
                "default": "#1F845A",
                "hovered": "#216E4E"
              },
              "boldest": {
                "default": "#216E4E",
                "hovered": "#164B35"
              }
            },
            "teal": {
              "bold": {
                "default": "#1D9AAA",
                "hovered": "#1D7F8C"
              },
              "bolder": {
                "default": "#1D7F8C",
                "hovered": "#206B74"
              },
              "boldest": {
                "default": "#206B74",
                "hovered": "#1D474C"
              }
            },
            "purple": {
              "bold": {
                "default": "#8F7EE7",
                "hovered": "#8270DB"
              },
              "bolder": {
                "default": "#8270DB",
                "hovered": "#6E5DC6"
              },
              "boldest": {
                "default": "#5E4DB2",
                "hovered": "#352C63"
              }
            },
            "magenta": {
              "bold": {
                "default": "#DA62AC",
                "hovered": "#CD519D"
              },
              "bolder": {
                "default": "#CD519D",
                "hovered": "#AE4787"
              },
              "boldest": {
                "default": "#943D73",
                "hovered": "#50253F"
              }
            },
            "gray": {
              "bold": {
                "default": "#8590A2",
                "hovered": "#758195"
              },
              "bolder": {
                "default": "#758195",
                "hovered": "#626F86"
              },
              "boldest": {
                "default": "#44546F",
                "hovered": "#2C3E5D"
              }
            },
            "lime": {
              "bold": {
                "default": "#6A9A23",
                "hovered": "#5B7F24"
              },
              "bolder": {
                "default": "#5B7F24",
                "hovered": "#4C6B1F"
              },
              "boldest": {
                "default": "#4C6B1F",
                "hovered": "#37471F"
              }
            }
          },
          "elevation": {
            "surface": {
              "default": {
                "[default]": "#FFFFFF",
                "hovered": "#F1F2F4",
                "pressed": "#DCDFE4"
              },
              "sunken": "#F7F8F9",
              "raised": {
                "default": "#FFFFFF",
                "hovered": "#F1F2F4",
                "pressed": "#DCDFE4"
              },
              "overlay": {
                "default": "#FFFFFF",
                "hovered": "#F1F2F4",
                "pressed": "#DCDFE4"
              }
            },
            "shadow": {
              "overflow": {
                "spread": "#091e4229",
                "perimeter": "#091e421f"
              }
            }
          }
        },
        "shadows": {
          "elevation": {
            "shadow": {
              "raised": "0px 1px 1px 0px #091e4240, 0px 0px 1px 0px #091e424f",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 8px 12px 0px #091e4226, 0px 0px 1px 0px #091e424f"
            }
          },
          "shadows": {
            "xs": "0px 1px 1px 0px #091e4240",
            "xxs": "0px 0px 1px 0px #091e424f",
            "md": "0px 8px 8px 0px #091e4214",
            "lg": "0px 8px 12px 0px #091e4226"
          }
        }
      },
      "dark": {
        "colors": {
          "text": {
            "default": "#C7D1DB",
            "subtle": "#9FADBC",
            "subtlest": "#8696A7",
            "disabled": "#596773",
            "inverse": "#161A1D",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#FF9C8F",
            "success": "#7EE2B8",
            "discovery": "#B8ACF6",
            "information": "#85B8FF",
            "accent": {
              "blue": {
                "default": "#85B8FF",
                "bolder": "#CCE0FF"
              },
              "red": {
                "default": "#FF9C8F",
                "bolder": "#FFD2CC"
              },
              "orange": {
                "default": "#FEC57B",
                "bolder": "#FFE2BD"
              },
              "yellow": {
                "default": "#F5CD47",
                "bolder": "#F8E6A0"
              },
              "green": {
                "default": "#7EE2B8",
                "bolder": "#BAF3DB"
              },
              "purple": {
                "default": "#B8ACF6",
                "bolder": "#DFD8FD"
              },
              "teal": {
                "default": "#8BDBE5",
                "bolder": "#C1F0F5"
              },
              "magenta": {
                "default": "#F797D2",
                "bolder": "#FDD0EC"
              },
              "gray": {
                "default": "#9FADBC",
                "bolder": "#C7D1DB"
              },
              "lime": {
                "default": "#B3DF72",
                "bolder": "#D3F1A7"
              }
            },
            "warning": {
              "default": "#F5CD47",
              "inverse": "#161A1D"
            }
          },
          "icon": {
            "default": "#9FADBC",
            "subtle": "#8696A7",
            "inverse": "#161A1D",
            "disabled": "#596773",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#F18D13",
              "yellow": "#CF9F02",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC",
              "gray": "#738496",
              "lime": "#82B536"
            },
            "warning": {
              "default": "#CF9F02",
              "inverse": "#161A1D"
            }
          },
          "border": {
            "default": "#a6c5e229",
            "inverse": "#161A1D",
            "focused": "#CCE0FF",
            "input": "#a6c5e229",
            "disabled": "#a1bdd914",
            "brand": "#579DFF",
            "selected": "#579DFF",
            "danger": "#EF5C48",
            "warning": "#F18D13",
            "success": "#2ABB7F",
            "discovery": "#8F7EE7",
            "information": "#388BFF",
            "subtle": "#a1bdd914",
            "accent": {
              "blue": "#388BFF",
              "red": "#EF5C48",
              "orange": "#FAA53D",
              "yellow": "#CF9F02",
              "green": "#2ABB7F",
              "purple": "#8F7EE7",
              "teal": "#37B4C3",
              "magenta": "#DA62AC",
              "table": {
                "default": "#a6c5e229"
              },
              "gray": "#738496"
            }
          },
          "background": {
            "disabled": "#a1bdd914",
            "accent": {
              "blue": {
                "subtlest": "#082145",
                "subtler": "#09326C",
                "subtle": "#0055CC",
                "bolder": "#579DFF"
              },
              "red": {
                "subtlest": "#391813",
                "subtler": "#601E16",
                "subtle": "#AE2A19",
                "bolder": "#F87462"
              },
              "orange": {
                "subtlest": "#43290F",
                "subtler": "#5F3811",
                "subtle": "#974F0C",
                "bolder": "#FAA53D"
              },
              "yellow": {
                "subtlest": "#3D2E00",
                "subtler": "#533F04",
                "subtle": "#7F5F01",
                "bolder": "#E2B203"
              },
              "green": {
                "subtlest": "#133527",
                "subtler": "#164B35",
                "subtle": "#216E4E",
                "bolder": "#4BCE97"
              },
              "teal": {
                "subtlest": "#153337",
                "subtler": "#1D474C",
                "subtle": "#206B74",
                "bolder": "#60C6D2"
              },
              "purple": {
                "subtlest": "#231C3F",
                "subtler": "#352C63",
                "subtle": "#5E4DB2",
                "bolder": "#9F8FEF"
              },
              "magenta": {
                "subtlest": "#341829",
                "subtler": "#50253F",
                "subtle": "#943D73",
                "bolder": "#E774BB"
              },
              "gray": {
                "subtlest": "#2C333A",
                "subtler": "#2C333A",
                "subtle": "#596773",
                "bolder": "#8696A7"
              },
              "lime": {
                "subtlest": "#2A3818",
                "subtler": "#37471F",
                "subtle": "#4C6B1F",
                "bolder": "#94C748"
              }
            },
            "inverse": {
              "subtle": {
                "default": "#ffffff29",
                "hovered": "#ffffff3d",
                "pressed": "#ffffff52"
              }
            },
            "input": {
              "default": "#1D2125",
              "hovered": "#22272B",
              "pressed": "#1D2125"
            },
            "neutral": {
              "default": {
                "[default]": "#a1bdd914",
                "hovered": "#a6c5e229",
                "pressed": "#bfdbf847"
              },
              "subtle": {
                "default": "#00000000",
                "hovered": "#a1bdd914",
                "pressed": "#a6c5e229"
              },
              "bold": {
                "default": "#9FADBC",
                "hovered": "#B6C2CF",
                "pressed": "#C7D1DB"
              }
            },
            "brand": {
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            },
            "selected": {
              "default": {
                "[default]": "#082145",
                "hovered": "#09326C",
                "pressed": "#0055CC"
              },
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            },
            "danger": {
              "default": {
                "[default]": "#391813",
                "hovered": "#601E16",
                "pressed": "#AE2A19"
              },
              "bold": {
                "default": "#F87462",
                "hovered": "#FF9C8F",
                "pressed": "#FFD2CC"
              }
            },
            "warning": {
              "default": {
                "[default]": "#3D2E00",
                "hovered": "#533F04",
                "pressed": "#7F5F01"
              },
              "bold": {
                "default": "#E2B203",
                "hovered": "#F5CD47",
                "pressed": "#F8E6A0"
              }
            },
            "success": {
              "default": {
                "[default]": "#133527",
                "hovered": "#164B35",
                "pressed": "#216E4E"
              },
              "bold": {
                "default": "#4BCE97",
                "hovered": "#7EE2B8",
                "pressed": "#BAF3DB"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#231C3F",
                "hovered": "#352C63",
                "pressed": "#5E4DB2"
              },
              "bold": {
                "default": "#9F8FEF",
                "hovered": "#B8ACF6",
                "pressed": "#DFD8FD"
              }
            },
            "information": {
              "default": {
                "[default]": "#082145",
                "hovered": "#09326C",
                "pressed": "#0055CC"
              },
              "bold": {
                "default": "#579DFF",
                "hovered": "#85B8FF",
                "pressed": "#CCE0FF"
              }
            }
          },
          "blanket": {
            "default": "#03040442",
            "selected": "#1d7afc14",
            "danger": "#e3493514"
          },
          "interaction": {
            "hovered": "#00000029",
            "pressed": "#00000052",
            "inverse": {
              "hovered": "#ffffff33",
              "pressed": "#ffffff5c"
            }
          },
          "skeleton": {
            "default": "#a1bdd914",
            "subtle": "#bcd6f00a"
          },
          "link": {
            "default": "#579DFF",
            "pressed": "#85B8FF",
            "visited": "#B8ACF6"
          },
          "chart": {
            "brand": {
              "default": "#388BFF",
              "hovered": "#579DFF"
            },
            "neutral": {
              "default": "#738496",
              "hovered": "#8696A7"
            },
            "success": {
              "default": {
                "[default]": "#2ABB7F",
                "hovered": "#4BCE97"
              },
              "bold": {
                "default": "#7EE2B8",
                "hovered": "#BAF3DB"
              }
            },
            "danger": {
              "default": {
                "[default]": "#E34935",
                "hovered": "#EF5C48",
                "pressed": "#AE2A19"
              },
              "bold": {
                "default": "#FF9C8F",
                "hovered": "#FFD2CC",
                "pressed": "#FFEDEB"
              }
            },
            "warning": {
              "default": {
                "[default]": "#CF9F02",
                "hovered": "#E2B203"
              },
              "bold": {
                "default": "#F5CD47",
                "hovered": "#F8E6A0"
              }
            },
            "information": {
              "default": {
                "[default]": "#1D7AFC",
                "hovered": "#388BFF"
              },
              "bold": {
                "default": "#85B8FF",
                "hovered": "#CCE0FF"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#8270DB",
                "hovered": "#8F7EE7"
              },
              "bold": {
                "default": "#B8ACF6",
                "hovered": "#DFD8FD"
              }
            },
            "categorical": {
              "1": {
                "default": "#1D9AAA",
                "hovered": "#37B4C3"
              },
              "2": {
                "default": "#B8ACF6",
                "hovered": "#DFD8FD"
              },
              "3": {
                "default": "#D97008",
                "hovered": "#F18D13"
              },
              "4": {
                "default": "#F797D2",
                "hovered": "#FDD0EC"
              },
              "5": {
                "default": "#CCE0FF",
                "hovered": "#E9F2FF"
              },
              "6": {
                "default": "#8270DB",
                "hovered": "#8F7EE7"
              },
              "7": {
                "default": "#FDD0EC",
                "hovered": "#FFECF8"
              },
              "8": {
                "default": "#FEC57B",
                "hovered": "#FFE2BD"
              }
            },
            "blue": {
              "bold": {
                "default": "#1D7AFC",
                "hovered": "#388BFF"
              },
              "bolder": {
                "default": "#388BFF",
                "hovered": "#579DFF"
              },
              "boldest": {
                "default": "#85B8FF",
                "hovered": "#CCE0FF"
              }
            },
            "red": {
              "bold": {
                "default": "#E34935",
                "hovered": "#EF5C48"
              },
              "bolder": {
                "default": "#EF5C48",
                "hovered": "#F87462"
              },
              "boldest": {
                "default": "#FF9C8F",
                "hovered": "#FFD2CC"
              }
            },
            "orange": {
              "bold": {
                "default": "#F18D13",
                "hovered": "#FAA53D"
              },
              "bolder": {
                "default": "#FAA53D",
                "hovered": "#FEC57B"
              },
              "boldest": {
                "default": "#FEC57B",
                "hovered": "#FFE2BD"
              }
            },
            "yellow": {
              "bold": {
                "default": "#CF9F02",
                "hovered": "#E2B203"
              },
              "bolder": {
                "default": "#E2B203",
                "hovered": "#F5CD47"
              },
              "boldest": {
                "default": "#F5CD47",
                "hovered": "#F8E6A0"
              }
            },
            "green": {
              "bold": {
                "default": "#2ABB7F",
                "hovered": "#4BCE97"
              },
              "bolder": {
                "default": "#4BCE97",
                "hovered": "#7EE2B8"
              },
              "boldest": {
                "default": "#7EE2B8",
                "hovered": "#BAF3DB"
              }
            },
            "teal": {
              "bold": {
                "default": "#37B4C3",
                "hovered": "#60C6D2"
              },
              "bolder": {
                "default": "#60C6D2",
                "hovered": "#8BDBE5"
              },
              "boldest": {
                "default": "#8BDBE5",
                "hovered": "#C1F0F5"
              }
            },
            "purple": {
              "bold": {
                "default": "#8270DB",
                "hovered": "#8F7EE7"
              },
              "bolder": {
                "default": "#8F7EE7",
                "hovered": "#9F8FEF"
              },
              "boldest": {
                "default": "#B8ACF6",
                "hovered": "#DFD8FD"
              }
            },
            "magenta": {
              "bold": {
                "default": "#CD519D",
                "hovered": "#DA62AC"
              },
              "bolder": {
                "default": "#DA62AC",
                "hovered": "#E774BB"
              },
              "boldest": {
                "default": "#F797D2",
                "hovered": "#FDD0EC"
              }
            },
            "gray": {
              "bold": {
                "default": "#738496",
                "hovered": "#8696A7"
              },
              "bolder": {
                "default": "#8696A7",
                "hovered": "#9FADBC"
              },
              "boldest": {
                "default": "#9FADBC",
                "hovered": "#B6C2CF"
              }
            },
            "lime": {
              "bold": {
                "default": "#82B536",
                "hovered": "#94C748"
              },
              "bolder": {
                "default": "#94C748",
                "hovered": "#B3DF72"
              },
              "boldest": {
                "default": "#B3DF72",
                "hovered": "#D3F1A7"
              }
            }
          },
          "elevation": {
            "surface": {
              "default": {
                "[default]": "#1D2125",
                "hovered": "#22272B",
                "pressed": "#22272B"
              },
              "sunken": "#161A1D",
              "raised": {
                "default": "#22272B",
                "hovered": "#22272B",
                "pressed": "#2C333A"
              },
              "overlay": {
                "default": "#22272B",
                "hovered": "#2C333A",
                "pressed": "#2C333A"
              }
            },
            "shadow": {
              "overflow": {
                "spread": "#0304048f",
                "perimeter": "#091e421f"
              }
            }
          }
        },
        "shadows": {
          "elevation": {
            "shadow": {
              "raised": "0px 1px 1px 0px #03040480, 0px 0px 1px 0px #03040480",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 0px 0px 1px #bcd6f00a, 0px 8px 12px 0px #0304045c, 0px 0px 1px 0px #03040480"
            }
          }
        }
      }
    }
  }
};

export { themePreval as default };
